import React, { useState } from "react";
import { useHistory } from "react-router-dom";
import {
  Box,
  Column,
  Columns,
  StackSection,
  Stack,
} from "@origin-digital/ods-core";

import { CallbackForm } from "../../components/CallbackForm/CallbackForm";
import { Cart } from "../../components/Cart/Cart";
import { useAppContext } from "../../context/AppContext";
import { Routes } from "../../consts";
import {
  NavigationURIType,
  submitNavigationEvent,
} from "../../utils/analytics";

export const CallbackScreen: React.FC = () => {
  const { context } = useAppContext();
  const history = useHistory();
  const [navEventFired, setNavEventFired] = useState<boolean>(false);

  if (!context.lookupAddress) {
    history.push(Routes.INDEX);
  }

  if (!navEventFired) {
    const {
      location: { href },
    } = window;
    submitNavigationEvent(href, NavigationURIType.REQUEST_CALLBACK);
    setNavEventFired(true);
  }

  return (
    <StackSection
      data-id="request-callback"
      backgroundColor="transparent"
      width="xlarge"
    >
      {context.selectedOffer ? (
        <Columns
          collapseBelow="lg"
          space="large"
          data-id="selected-offer-section"
        >
          <Column width="2/3">
            <Stack space={["xsmall", "large"]}>
              <CallbackForm />
            </Stack>
          </Column>
          <Column width="1/3">
            {context.selectedOffer && <Cart offer={context.selectedOffer} />}
          </Column>
        </Columns>
      ) : (
        <Box
          width="full"
          style={{ marginLeft: "auto", marginRight: "auto", maxWidth: "700px" }}
        >
          <CallbackForm />
        </Box>
      )}
    </StackSection>
  );
};
